import PageHeader from './PageHeader'

/**
 * Единый компонент для всех страниц и секций.
 * Один паттерн: заголовок + бейдж (слева), действия/ссылка «Назад» (справа), подсказка, контент.
 * Используется везде: Модели, Фаны, Чаты, Конфигурации, Пользователи, Граф, Логи и т.д.
 */
export default function PageSection({
  title,
  subtitle,
  hint,
  badge,
  backHref,
  backLabel,
  actions,
  children,
  className = '',
  contentClassName = '',
  /** Не показывать отступ снизу у заголовка (когда контент в табах/карточках) */
  compact = false,
}) {
  const sub = subtitle || hint
  return (
    <div className={`page-section ${compact ? 'page-section--compact' : ''} ${className}`.trim()}>
      <PageHeader
        title={title}
        subtitle={sub}
        badge={badge}
        backHref={backHref}
        backLabel={backLabel}
        className={compact ? 'page-header--compact' : ''}
      >
        {actions}
      </PageHeader>
      {children && <div className={`page-section-content ${contentClassName}`.trim()}>{children}</div>}
    </div>
  )
}
